import { render, staticRenderFns } from "./DefaultPlans.vue?vue&type=template&id=11352838&scoped=true&"
import script from "./DefaultPlans.vue?vue&type=script&lang=js&"
export * from "./DefaultPlans.vue?vue&type=script&lang=js&"
import style0 from "./DefaultPlans.vue?vue&type=style&index=0&id=11352838&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11352838",
  null
  
)

export default component.exports